import { transformDateValue } from 'core/js/FormUtils';
export const getProductassetView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let productassetList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"String"), "fieldType":"String"},
                            {"fieldLabel":"Asset Path","fieldValue":transformDataValue(data.assetpath,"string"), "fieldType":"string"},
                            {"fieldLabel":"Design Vendor Name","fieldValue":transformDataValue(data.designvendorname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Ordered On","fieldValue":transformDataValue(data.orderedon,"date"), "fieldType":"date"},
                            {"fieldLabel":"Received On","fieldValue":transformDataValue(data.receivedon,"date"), "fieldType":"date"},
                            {"fieldLabel":"Path","fieldValue":transformDataValue(data.path,"string"), "fieldType":"string"},
                            {"fieldLabel":"Name","fieldValue":transformDataValue(data.name,"string"), "fieldType":"string"},
                            {"fieldLabel":"Asset Id","fieldValue":transformDataValue(data.assetid,"number"), "fieldType":"number"},
                            {"fieldLabel":"designstatus","fieldValue":transformDataValue(data.designstatus,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          productassetList.push(card);
  })
  return productassetList;
}